"use strict";
import('./main');
